'use client'
import Image from 'next/image'

function StateImageSection({ imageUrl, alt, caption }) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-8 md:px-6">
      <div className="w-full flex justify-center">
        {/* Image Container */}
        <div className="relative">
          <div className="relative w-[335px] h-[171px] md:w-[640px] md:h-[300px] bg-[#E7ECF3] rounded overflow-hidden">
            {imageUrl ? (
              <Image
                src={imageUrl}
                alt={alt || 'State image'}
                fill
                className="object-cover"
                sizes="(max-width: 768px) 335px, 640px"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <span className="text-sm">Image placeholder</span>
              </div>
            )}
          </div>

          {/* Caption */}
          {caption && <p className="mt-3 text-sm text-gray-600 text-center">{caption}</p>}
        </div>
      </div>
    </section>
  )
}

export { StateImageSection }
export default StateImageSection
